import GainOverview from '../GainOverview.vue';
import GainApiNextRuns from '../GainApiNextRuns.vue';
import GainApiRuns from '../GainApiRuns.vue';
import GainBatches from '../GainBatches.vue';
import GainPromotions from '../GainPromotions.vue';
import GainRequirementsStatus from '../GainRequirementsStatus.vue';

export default {
  path: '/gain',
  name: 'GainOverview',
  redirect: { name: 'GainBatches' },
  component: GainOverview,
  meta: { menuItemName: 'Gain' },
  children: [
    {
      path: 'batches',
      name: 'GainBatches',
      component: GainBatches
    },
    {
      path: 'requirements-status',
      name: 'GainRequirementsStatus',
      component: GainRequirementsStatus
    },
    {
      path: 'promotions',
      name: 'GainPromotions',
      component: GainPromotions
    },
    {
      path: 'api-next-runs',
      name: 'GainApiNextRuns',
      component: GainApiNextRuns
    },
    {
      path: 'api-runs',
      name: 'GainApiRuns',
      component: GainApiRuns
    }
  ]
};
